// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessageRepo_GetMessagesByChatIdInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /message_repo/getMessagesByChatID
 *
 * Validates the chat_id used to fetch all messages for a given chat.
 */
import { registerContract } from './validate'

export interface MessageRepo_GetMessagesByChatIdInput {
chat_id: string
}

registerContract('MessageRepo_GetMessagesByChatIdInput', {
  chat_id: { type: 'string',  required: true },
})
